export default __webpack_public_path__ + "static/events-88fdff20cbfc8690cd8b7163ec281107.png";